import { render, staticRenderFns } from "./OverlayNewsletter.vue?vue&type=template&id=4eb8fa58&"
import script from "./OverlayNewsletter.vue?vue&type=script&lang=js&"
export * from "./OverlayNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./OverlayNewsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports